// src/layouts/Pages/PageHeader/CardHeaderColumns/items/ie.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { FileDoneOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import { parseIeToDisplay, returnOnlyNumbers } from 'utils/helpers';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const ieItem = record => {
  const issuerUf = record?.address?.region;
  const rawIe = record?.fiscalData?.stateRegistration || record?.ie;
  const ie = rawIe && parseIeToDisplay(rawIe, issuerUf);

  return {
    key: 'ie',
    icon: <FileDoneOutlined />,
    label: ie || translateX('n_a'),
    tooltipText: translateX('state_registration'),
    tooltipPlacement: 'right',
    onClick: ie ? () => appService.handleCopyToClipboard(returnOnlyNumbers(ie), 'ie_copied') : null,
  };
};

export default ieItem;
